import { Component } from '@angular/core';

@Component({
    selector: 'ukho-accessibility',
    standalone: true,
    templateUrl: './accessibility.component.html',
    styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent {}
